import { Box, Button, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { NeroliOrchideeProductItemProps } from '../../../interfaces/components';

const NeroliOrchideeProductItem = ({
  activeLocale,
  image,
  title,
  size,
  price,
  onClick,
}: NeroliOrchideeProductItemProps) => {
  return (
    <Box
      width={'50%'}
      height={'100%'}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      gap={[2, 2, 2, 3, 3]}
    >
      <Image
        loading="lazy"
        width={['40px', '50px', '50px', '100px', '100px']}
        height={['60px', '70px', '70px', '100px', '100px']}
        objectFit="contain"
        src={image}
        alt="Product Image"
      />
      <Text
        fontSize={['13px', '14px', '14px', '16px', '16px']}
        fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayRegular'}
        fontWeight="400"
        textAlign="center"
      >
        {title}
      </Text>
      <Box
        width={'100%'}
        height={'fit-content'}
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        gap={3}
      >
        {size && (
          <>
            <Text
              fontSize={['13px', '14px', '14px', '16px', '16px']}
              fontFamily={'RalewaySemiBold'}
              fontWeight="400"
              textAlign="center"
            >
              {size}
            </Text>
            <Box width={'2px'} height={'20px'} bgColor={'#DADADA'} />
          </>
        )}
        <Text
          fontSize={['13px', '14px', '14px', '16px', '16px']}
          fontFamily={'RalewaySemiBold'}
          fontWeight="400"
          textAlign="center"
        >
          {price}
        </Text>
      </Box>
      <Button
        variant="outline"
        borderColor="#000"
        borderWidth="2px"
        color="black"
        borderRadius="0px"
        h={['30px', '40px', '40px', '40px', '50px']}
        w={['150px', '150px', '150px', '150px', '150px']}
        bg="transparent"
        fontSize={['10px', '10px', '10px', '12px', '12px']}
        _hover={{ bg: '#FFCB00' }}
        _active={{ bg: '#FFCB00' }}
        _focus={{ bg: '#FFCB00' }}
        cursor="pointer"
        pointerEvents="auto"
        fontFamily={activeLocale === 'ar' ? 'GETwoBold' : 'RalewaySemiBold'}
        onClick={onClick}
      >
        {activeLocale === 'ar' ? 'أضف إلى حقيبة التسوق' : 'ADD TO BAG'}
      </Button>
    </Box>
  );
};

export default NeroliOrchideeProductItem;
